var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDecaHw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#F4F4F5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.6,10.65H2.93V14.5h9.52c4.94,0,10.2,2.08,10.2,9s-5.25,9-10.2,9H6.88V18.3H2.93V36.35H12.6c7.34,0,14.16-4,14.16-12.85S19.94,10.65,12.6,10.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44,10.08a13.42,13.42,0,1,0-.33,26.84H44c5.83,0,11.18-3.38,12.8-8.74H52.51C51.26,31,48.45,33,44.08,33a9.2,9.2,0,0,1-9.42-8.59H57.14a8.76,8.76,0,0,0,.1-1.45A13,13,0,0,0,44.17,10.08ZM35,20.59A9.27,9.27,0,0,1,43.93,14c4.21,0,7.7,2.24,8.79,6.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.94,14c4,0,6.87,1.67,8.37,4.84h4.38a13,13,0,0,0-12.75-8.79,13.42,13.42,0,0,0,0,26.84h0a13,13,0,0,0,12.75-8.74H82.31C80.81,31.51,77.84,33,73.94,33a9.47,9.47,0,0,1,0-18.94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M113.12,10.65v4.11a12.17,12.17,0,0,0-9.94-4.68,13.42,13.42,0,0,0,0,26.84,12.18,12.18,0,0,0,9.94-4.68v4.11h3.95V10.65ZM103.54,33a9.52,9.52,0,0,1,0-19,9.24,9.24,0,0,1,9.52,9,5.42,5.42,0,0,1,0,.57A9.39,9.39,0,0,1,103.79,33Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDecaHw);
export default __webpack_public_path__ + "static/media/logo-deca-hw.183e383376114cd137509a8009441b7a.svg";
export { ForwardRef as ReactComponent };